export default __webpack_public_path__ + "static/media/mastercard.2331aed2.svg";